// extracted by mini-css-extract-plugin
module.exports = {"root":"ShoutOuts_root__3-rVP","title":"ShoutOuts_title__2ktUy"};